import { Formik, Form } from 'formik';
import { useCallback } from 'react';
import { useState } from 'react';
import { useTheme, DefaultTheme } from 'styled-components';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import * as yup from 'yup';
import { FiLock, FiUser } from 'react-icons/fi';
import { FaLock } from 'react-icons/fa';
import { FaSpotify } from 'react-icons/fa';
import { Button } from '../../../components/Button';
import { Input } from '../../../components/Input';
import { useAuth } from '../../../hooks/auth';

const data = {
  email: '',
  password: '',
};

const schema = yup.object({
  email: yup
    .string()
    .email('Digite um email válido')
    .required('Digite seu email'),
  password: yup.string().required('Digite sua senha'),
});

interface SubmitProps {
  password: string;
  email: string;
}

export const SignIn = () => {
  const theme: DefaultTheme = useTheme();
  const { signIn } = useAuth();
  const [loading, setLoading] = useState(false);

  const handleSubmit = useCallback(
    async ({ email, password }: SubmitProps) => {
      try {
        setLoading(true);
        await signIn({
          email,
          password,
        });
      } catch (err: any) {
        if (err.response.data.message) {
          toast.error(err.response.data.message);
          return;
        }
        toast.error('Erro ao realizar login');
      } finally {
        setLoading(false);
      }
    },
    [signIn],
  );

  return (
    <Formik
      initialValues={data}
      validationSchema={schema}
      onSubmit={handleSubmit}
    >
      <Form>
        <h5 className="text-center">
          <FaSpotify
            size={65}
            color={theme.colors.secondary}
            className="mr-2"
          />
        </h5>
        <h4 className="text-center mt-3 mb-3">Faça seu login</h4>
        <h6>Informe seus dados abaixo para acessar a sua conta</h6>
        <Input
          type="email"
          name="email"
          icon={FiUser}
          placeholder="Seu username"
        />

        <Input
          name="password"
          type="password"
          icon={FiLock}
          placeholder="Sua senha"
        />

        <Button
          className="mt-4"
          type="submit"
          background={theme.colors.secondary}
          loading={loading || undefined}
          color="#fff"
        >
          Entrar
        </Button>

        <div className="mt-1 text-center d-block">
          <Link to="/auth/forgot">Esqueci minha senha</Link>
        </div>

        <div className="d-flex justify-content-center mt-5">
          <Link
            to="/auth/confirmEmail"
            className="link-redirect d-flex align-items-center"
          >
            Cadastrar senha
            <FaLock className="ml-1" />
          </Link>
        </div>
      </Form>
    </Formik>
  );
};
